<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 16.715 10.311"
  >
    <path
      stroke="currentColor"
      stroke-width="2"
      d="M7.539 6.504 2.382 1.349a.841.841 0 0 0-1.153 0 .841.841 0 0 0 0 1.155l6.548 6.579a.739.739 0 0 0 .271.17.94.94 0 0 0 .611 0 .739.739 0 0 0 .271-.17l6.547-6.579a.819.819 0 0 0 0-1.153.841.841 0 0 0-1.153 0L9.167 6.504Z"
    />
  </svg>
</template>
